import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2, AlertTriangle, Info, X } from 'lucide-react';
import { subscribeToasts, toast } from '../lib/toast';

const META = {
  success: { Icon: CheckCircle2, color: '#5AA37A' },
  error: { Icon: AlertTriangle, color: '#B23B36' },
  info: { Icon: Info, color: 'var(--accent-gold)' },
};

/**
 * Toaster — pile de notifications en bas à droite. Sobre, chaud, animé (framer-motion).
 * Monté une seule fois à la racine. Clic = fermeture.
 */
export default function Toaster() {
  const [items, setItems] = useState([]);
  useEffect(() => subscribeToasts(setItems), []);

  return (
    <div
      style={{ position: 'fixed', right: 20, bottom: 20, zIndex: 99999, display: 'flex', flexDirection: 'column', gap: 10, width: 'min(380px, calc(100vw - 40px))', pointerEvents: 'none' }}
      aria-live="polite"
    >
      <AnimatePresence initial={false}>
        {items.map((t) => {
          const m = META[t.type] || META.info;
          const Icon = m.Icon;
          return (
            <motion.div
              key={t.id}
              layout
              initial={{ opacity: 0, x: 28, scale: 0.96 }}
              animate={{ opacity: 1, x: 0, scale: 1 }}
              exit={{ opacity: 0, x: 28, scale: 0.96 }}
              transition={{ duration: 0.26, ease: [0.22, 0.61, 0.36, 1] }}
              onClick={() => toast.dismiss(t.id)}
              role="status"
              style={{
                pointerEvents: 'auto',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'flex-start',
                gap: 11,
                padding: '13px 14px',
                borderRadius: 12,
                background: 'var(--widget-bg)',
                border: '1px solid var(--border-soft)',
                boxShadow: '0 18px 44px rgba(0,0,0,0.42)',
              }}
            >
              <Icon className="w-4 h-4" style={{ color: m.color, marginTop: 1, flexShrink: 0 }} />
              <div style={{ flex: 1, fontSize: 13, lineHeight: 1.45, color: 'var(--text-primary)', wordBreak: 'break-word' }}>{t.message}</div>
              {t.action && (
                <button
                  onClick={(e) => { e.stopPropagation(); try { t.action.onClick(); } finally { toast.dismiss(t.id); } }}
                  style={{ flexShrink: 0, fontSize: 12, fontWeight: 600, color: 'var(--accent-gold)', background: 'transparent', border: 'none', cursor: 'pointer', padding: '0 2px', whiteSpace: 'nowrap', marginTop: 1 }}
                >
                  {t.action.label}
                </button>
              )}
              <X className="w-3.5 h-3.5" style={{ color: 'var(--text-tertiary)', flexShrink: 0, marginTop: 1 }} />
            </motion.div>
          );
        })}
      </AnimatePresence>
    </div>
  );
}
